import SendFileForMessage from './SendFileForMessage';

export default SendFileForMessage;
